import GeneratedCalendarServiceApi from "./generated/GeneratedCalendarServiceApi"

class CalendarServiceApi extends GeneratedCalendarServiceApi {

}

export const calendarServiceApi = new CalendarServiceApi()
